import { makeStyles, TextField } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import BackNextButton from '../../../base/buttons/backNextButton';

export default function SelectEnvComponent(props) {

    const classes = useStyles();

    const onChangeItem = (event) => {
        props.changeEnv(event.target.value)
    }

    const next = () => {
        props.setNext()
    }

    return (

        <div className={classes.container}>
            <div className={classes.title}>
                Select environment:
            </div>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select2"
                className={classes.envSelect}
                value={props.env.id}
                defaultValue={props.env.id}
                disableUnderline
                onChange={(e) => onChangeItem(e)}
            >
                {props.appSettings.ENVIRONMENTS.map(x => {
                    return (
                        <MenuItem value={x.id} key={x.id}>{x.name + " - " + x.DBName}</MenuItem>)
                })}

            </Select>
            <BackNextButton next action = {next}></BackNextButton>

        </div>
    )
}

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "500px",
        width: "50%",
    },
    title: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        fontSize: "22px",
        marginBottom: "30px"
    },   
    envSelect: {
        height: 44,
        backgroundColor: "white",
        borderWidth: 1,
        marginBottom: 10,
        width: "100%",
        border: "1px solid lightgrey"
    }

});